const RETRYABLE_MESSAGES = [
  'network',
  'timeout',
  'temporarily unavailable',
  'rate limit',
  '503',
  '429',
  '502',
  '504',
  'econnreset',
  'econnrefused',
  'etimedout',
  'enotfound',
  'socket hang up',
];

export function isRetryableUploadError(error: unknown): boolean {
  const message =
    error instanceof Error
      ? error.message.toLowerCase()
      : String(error).toLowerCase();

  return RETRYABLE_MESSAGES.some((candidate) => message.includes(candidate));
}
